import { AlertType, RiskType } from '../models';

enum RiskKeys {
  EXCHANGE = 'exchange',
  TRUSTED_EXCHANGE = 'trusted_exchange',
  WALLET = 'wallet',
  MINER = 'miner',
  PAYMENT = 'payment',
  MARKETPLACE = 'marketplace',
  EXCHANGE_MLRISK_LOW = 'exchange_mlrisk_low',
  P2P_EXCHANGE_MLRISK_LOW = 'p2p_exchange_mlrisk_low',
  SEIZED_ASSETS = 'seized_assets',
  P2P_EXCHANGE = 'p2p_exchange',
  MERCHANT_SERVICES = 'merchant_services',
  ICO = 'ico',
  OTHER = 'other',
  BRIDGE = 'bridge',
  NFT_PLATFORM_COLLECTION = 'nft_platform_collection',

  ATM = 'atm',
  RISKY_EXCHANGE = 'risky_exchange',
  EXCHANGE_MLRISK_MODERATE = 'exchange_mlrisk_moderate',
  EXCHANGE_MLRISK_HIGH = 'exchange_mlrisk_high',
  EXCHANGE_MLRISK_VERYHIGH = 'exchange_mlrisk_veryhigh',
  P2P_EXCHANGE_MLRISK_HIGH = 'p2p_exchange_mlrisk_high',
  LIQUIDITY_POOLS = 'liquidity_pools',
  INFRASTRUCTURE_AS_A_SERVICE = 'infrastructure_as_a_service',
  DECENTRALIZED_EXCHANGE_CONTRACT = 'decentralized_exchange_contract',
  SMART_CONTRACT = 'smart_contract',
  TOKEN_SMART_CONTRACT = 'token_smart_contract',
  PROTOCOL_PRIVACY = 'protocol_privacy',
  UNNAMED_SERVICE = 'unnamed_service',
  LENDING_CONTRACT = 'lending_contract',

  RANSOM = 'ransom',
  DARK_MARKET = 'dark_market',
  DARK_SERVICE = 'dark_service',
  ILLEGAL_SERVICE = 'illegal_service',
  MIXER = 'mixer',
  SCAM = 'scam',
  STOLEN_COINS = 'stolen_coins',
  EXCHANGE_FRAUDULENT = 'exchange_fraudulent',
  GAMBLING = 'gambling',
  CHILD_EXPLOITATION = 'child_exploitation',
  SANCTIONS = 'sanctions',
  TERRORISM_FINANCING = 'terrorism_financing',
  FRAUD_SHOP = 'fraud_shop',
  ILLICIT_ACTOR_ORG = 'illicit_actor_org',
  HIGH_RISK_JURISDICTION = 'high_risk_jurisdiction',
  ENFORCEMENT_ACTION = 'enforcement_action',
  SPECIAL_MEASURES = 'special_measures',
  ONLINE_PHARMACY = 'online_pharmacy',
  MALWARE = 'malware',

  UNNAMED_ENTITY_LOW_RISK = 'unnamed_entity_low_risk',
  UNNAMED_ENTITY_MEDIUM_RISK = 'unnamed_entity_medium_risk',
  UNNAMED_ENTITY_HIGH_RISK = 'unnamed_entity_high_risk',
}

const LOW_RISK_KEY_LIST: RiskKeys[] = [
  RiskKeys.EXCHANGE,
  RiskKeys.TRUSTED_EXCHANGE,
  RiskKeys.WALLET,
  RiskKeys.MINER,
  RiskKeys.PAYMENT,
  RiskKeys.MARKETPLACE,
  RiskKeys.EXCHANGE_MLRISK_LOW,
  RiskKeys.P2P_EXCHANGE_MLRISK_LOW,
  RiskKeys.SEIZED_ASSETS,
  RiskKeys.P2P_EXCHANGE,
  RiskKeys.MERCHANT_SERVICES,
  RiskKeys.ICO,
  RiskKeys.OTHER,
  RiskKeys.BRIDGE,
  RiskKeys.NFT_PLATFORM_COLLECTION,
  RiskKeys.UNNAMED_ENTITY_LOW_RISK,
];

const MIDDLE_RISK_KEY_LIST: RiskKeys[] = [
  RiskKeys.ATM,
  RiskKeys.RISKY_EXCHANGE,
  RiskKeys.EXCHANGE_MLRISK_MODERATE,
  RiskKeys.EXCHANGE_MLRISK_HIGH,
  RiskKeys.EXCHANGE_MLRISK_VERYHIGH,
  RiskKeys.P2P_EXCHANGE_MLRISK_HIGH,
  RiskKeys.LIQUIDITY_POOLS,
  RiskKeys.INFRASTRUCTURE_AS_A_SERVICE,
  RiskKeys.DECENTRALIZED_EXCHANGE_CONTRACT,
  RiskKeys.SMART_CONTRACT,
  RiskKeys.TOKEN_SMART_CONTRACT,
  RiskKeys.PROTOCOL_PRIVACY,
  RiskKeys.UNNAMED_SERVICE,
  RiskKeys.LENDING_CONTRACT,
  RiskKeys.UNNAMED_ENTITY_MEDIUM_RISK,
];

const HIGH_RISK_KEY_LIST: RiskKeys[] = [
  RiskKeys.RANSOM,
  RiskKeys.DARK_MARKET,
  RiskKeys.DARK_SERVICE,
  RiskKeys.ILLEGAL_SERVICE,
  RiskKeys.MIXER,
  RiskKeys.SCAM,
  RiskKeys.STOLEN_COINS,
  RiskKeys.EXCHANGE_FRAUDULENT,
  RiskKeys.GAMBLING,
  RiskKeys.CHILD_EXPLOITATION,
  RiskKeys.SANCTIONS,
  RiskKeys.TERRORISM_FINANCING,
  RiskKeys.FRAUD_SHOP,
  RiskKeys.ILLICIT_ACTOR_ORG,
  RiskKeys.HIGH_RISK_JURISDICTION,
  RiskKeys.ENFORCEMENT_ACTION,
  RiskKeys.SPECIAL_MEASURES,
  RiskKeys.ONLINE_PHARMACY,
  RiskKeys.MALWARE,
  RiskKeys.UNNAMED_ENTITY_HIGH_RISK,
];

const RISK_KEY_SUBSTITUTIONS: Record<string, RiskKeys> = {
  exchange_licensed: RiskKeys.EXCHANGE,
  exchange_unlicensed: RiskKeys.RISKY_EXCHANGE,
  p2p_exchange_licensed: RiskKeys.P2P_EXCHANGE,
  p2p_exchange_unlicensed: RiskKeys.P2P_EXCHANGE_MLRISK_HIGH,
};

const RISK_GROUPS: Record<RiskType, RiskKeys[]> = {
  danger: HIGH_RISK_KEY_LIST,
  suspicious: MIDDLE_RISK_KEY_LIST,
  trusted: LOW_RISK_KEY_LIST,
};

enum RiskBadgeColors {
  GREEN = 'trusted',
  ORANGE = 'suspicious',
  RED = 'danger',
}

enum RiskProfileInfluenceEnum {
  NONE = 'none',
  LOW = 'low',
  MEDIUM = 'mid',
  HIGH = 'high',
}

const SIGNAL_INFLUENCES: Record<RiskProfileInfluenceEnum, string> = {
  [RiskProfileInfluenceEnum.NONE]: 'N/A',
  [RiskProfileInfluenceEnum.LOW]: 'Low',
  [RiskProfileInfluenceEnum.MEDIUM]: 'Medium',
  [RiskProfileInfluenceEnum.HIGH]: 'High',
};

const INFLUENCES_TO_DISPLAY: Record<RiskProfileInfluenceEnum, AlertType> = {
  [RiskProfileInfluenceEnum.NONE]: 'na',
  [RiskProfileInfluenceEnum.LOW]: 'low',
  [RiskProfileInfluenceEnum.MEDIUM]: 'medium',
  [RiskProfileInfluenceEnum.HIGH]: 'high',
};

export {
  RiskKeys,
  RISK_GROUPS,
  RiskBadgeColors,
  RISK_KEY_SUBSTITUTIONS,
  RiskProfileInfluenceEnum,
  SIGNAL_INFLUENCES,
  INFLUENCES_TO_DISPLAY,
};
